import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { authApi, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export function useAuthForm() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [role, setRole] = useState("doctor");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const toggleMode = () => { setMode((m) => (m === "login" ? "register" : "login")); setError(""); };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = mode === "login"
        ? await authApi.login({ email: form.email, password: form.password })
        : await authApi.register({ ...form, role });
      setUser(data);
      toast.success(`Welcome${data.name ? ", " + data.name : ""}`);
      navigate("/workflow");
    } catch (e2) {
      setError(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return { mode, role, setRole, form, upd, error, loading, submit, toggleMode };
}
